import { Stack } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { Button, EqualWidthGrid } from "@tfg/ui"

import { TypesFormProps } from "~/pages/Admin/components/TypesForm"

type TypesFormActionsSectionProps<T extends Record<string, unknown>> = Pick<
  TypesFormProps<T>,
  "closeDrawer" | "cancelLabel" | "submitLabel" | "readonly"
> & {
  form: UseFormReturnType<T>
}

export const TypesFormActionsSection = <T extends Record<string, unknown>>({
  form,
  closeDrawer,
  cancelLabel,
  submitLabel,
  readonly = false,
}: TypesFormActionsSectionProps<T>) => {
  if (readonly) {
    return null
  }

  return (
    <Stack py="md" pos="sticky" bg="white" bottom={0} left={0} right={0}>
      <EqualWidthGrid>
        <Button size="sm" variant="tertiary" onClick={closeDrawer} fullWidth>
          {cancelLabel}
        </Button>
        <Button size="sm" disabled={!form.isValid()} type="submit" fullWidth>
          {submitLabel}
        </Button>
      </EqualWidthGrid>
    </Stack>
  )
}
